export const ContentTypeGroup = Object.freeze({
  PARTNER_CONTENT: 5
})
